import React, { useContext, useEffect, useRef, useState } from "react";
import "./FilterModal.css";
import closeSvg from "../../../../assets/closeSvg";
import { EditNoteContext } from "../ClientPanels/EditNoteContext";
import { AppContext } from "../../../../AppContext";
import { logActivity, sendTextNotification } from "../../../utils";

const EditNotesModal = () => {
  const {
    noteEdit,
    setNoteEdit,
    notes,
    setNotes,
    userType,
    id,
    loanOfficerName,
    agentPartner,
    clientName,
    loanOfficerEmail,
    agentEmail,
    coAgentName,
    loanOfficerPhone,
    agentPhone,
    coAgentPhone,
    loanOfficerTextNotifications,
    agentTextNotifications,
    coAgentTextNotifications,
  } = useContext(EditNoteContext);

  const {
    userName,
    matrixData,
    setMatrixData,
    userEmail,
    makeKey,
    userPhone,
    path,
    userCompany,
  } = useContext(AppContext);

  useEffect(() => {
    setTemporaryNotes(notes);
  }, [notes]);

  const phoneNumbersArray =
    typeof coAgentPhone == undefined
      ? [
          {
            phone: loanOfficerPhone,
            notifications: loanOfficerTextNotifications,
          },
          { phone: agentPhone, notifications: agentTextNotifications },
        ]
      : [
          {
            phone: loanOfficerPhone,
            notifications: loanOfficerTextNotifications,
          },
          { phone: agentPhone, notifications: agentTextNotifications },
          { phone: coAgentPhone, notifications: coAgentTextNotifications },
        ];

  const notUserPhoneNumbers = phoneNumbersArray.filter((e) => {
    if (userPhone && e.phone) {
      return (
        e.phone.replace(/[^0-9.]+/g, "") !== userPhone.replace(/[^0-9.]+/g, "")
      );
    } else {
      return e.phone !== null;
    }
  });

  const [noteLength, setNoteLength] = useState(notes ? notes.length : 0);
  const [temporaryNotes, setTemporaryNotes] = useState(notes);

  const checkboxRef = useRef(null);

  const secretUrls = `/.netlify/functions/secretUrls`;

  let agentEmailOne = "";
  let agentEmailTwo = "";
  if (agentEmail && agentEmail.includes(",")) {
    const agentEmailArray = agentEmail.split(",");
    agentEmailOne = agentEmailArray[0];
    agentEmailTwo = agentEmailArray[1];
  } else if (agentEmail) {
    agentEmailOne = agentEmail;
  } else {
    //Basically if agent email does not exist, we are assigning it a valid email address so that the LO can still click the buttons and send notifications to the processing team.
    agentEmailOne = userEmail;
  }

  const updateMatrix = () => {
    if (userEmail.toLowerCase() != "blake@smith.com") {
      fetch(secretUrls, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          fetch(data.editNoteUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              apiKey: makeKey,
              id: id,
              userType: userType,
              sendNotification: checkboxRef.current.checked,
              note: temporaryNotes,
              userEmail: userEmail,
              userName: userName,
              agentPartner: agentPartner,
              agentEmailOne: agentEmailOne,
              agentEmailTwo: agentEmailTwo,
              loanOfficerName: loanOfficerName,
              loanOfficerEmail: loanOfficerEmail,
              coAgentName: coAgentName,
              clientName: clientName,
            }),
          });
        });
    }
  };

  return (
    <>
      <div className={`Modal-background filter ${noteEdit}`}></div>
      <div className={`filter-modal-container ${noteEdit}`}>
        <div className={`filter-modal editNotes ${noteEdit}`}>
          <div className="modal-container">
            <div className="spaceBetween">
              <div>
                <b>{clientName}</b>
              </div>
              <div
                onClick={(e) => {
                  setNoteEdit("hidden");
                }}
              >
                {closeSvg}
              </div>
            </div>
            <textarea
              className="fieldInput order-1"
              maxLength={255}
              type="text"
              onChange={(e) => {
                setNoteLength(e.target.value.length);
                setTemporaryNotes(e.target.value);
              }}
              value={temporaryNotes ? temporaryNotes : ""}
            ></textarea>
            <div className="textAlignRight">{noteLength}/255</div>
            {userType === "Loan Officer" ? (
              <div className="checkboxRow order-2">
                Notify agent
                <input
                  className="modalCheckbox"
                  ref={checkboxRef}
                  type="checkbox"
                  defaultChecked
                ></input>
              </div>
            ) : (
              <div className="checkboxRow">
                <input
                  className="modalCheckbox hidden"
                  ref={checkboxRef}
                  type="checkbox"
                  defaultChecked
                ></input>
                Clicking "Save" will update agent notes and send a notification
                to {loanOfficerName}.
              </div>
            )}
            <button
              className="button order-3"
              onClick={(e) => {
                e.stopPropagation();
                if (temporaryNotes) {
                  let confirmSendText = true;
                  let pushUpdate = true;
                  if (userType == "Loan Officer") {
                    if (checkboxRef.current.checked) {
                      confirmSendText = window.confirm(
                        "Click OK to update the note and send a notification."
                      );
                      pushUpdate = confirmSendText;
                    } else {
                      confirmSendText = false;
                    }
                  } else {
                    confirmSendText = window.confirm(
                      "Click OK to update the note and send a notification."
                    );
                    pushUpdate = confirmSendText;
                  }
                  if (pushUpdate) {
                    setNoteEdit("hidden");
                    setNotes(temporaryNotes);
                    const currentContact = JSON.parse(
                      matrixData[0]["Clients"]
                    ).find((e) => e.Id === id);
                    if (userType === "Agent") {
                      currentContact["Agent_Notes_via_App__c"] = temporaryNotes;
                    } else if (userType === "Loan Officer") {
                      currentContact["Matrix_App_Notes__c"] = temporaryNotes;
                    }
                    const updatedClients = JSON.parse(
                      matrixData[0]["Clients"]
                    ).map((e) => {
                      if (e.Id === id) {
                        return currentContact;
                      } else {
                        return e;
                      }
                    });
                    const updatedData = [
                      {
                        Clients: JSON.stringify(updatedClients),
                        UnderContract: matrixData[0]["UnderContract"],
                      },
                    ];
                    updateMatrix();
                    logActivity({
                      apiKey: makeKey,
                      userEmail: userEmail,
                      userType: userType,
                      action: "Note Edited",
                      tab: "Modal",
                      userCompany: userCompany,
                    });
                    setMatrixData(updatedData);
                  }
                  if (confirmSendText) {
                    for (let i = 0; i < notUserPhoneNumbers.length; i++) {
                      sendTextNotification({
                        textNotificationsAllowed:
                          notUserPhoneNumbers[i].notifications,
                        textMessage: `${clientName} | ${userName} says: ${temporaryNotes}\n\nRespond in Matrix: https://movematrix.netlify.app${path}`,
                        textPhone: notUserPhoneNumbers[i].phone,
                      });
                    }
                  }
                } else {
                  alert("Note is blank and was not sent.");
                }
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditNotesModal;
